/**
 * In-memory, decoded PCM audio — the working representation passed between all
 * audio operations in this package.
 *
 * Named `PcmAudio` (not `AudioData`) deliberately: `AudioData` is a WebCodecs
 * DOM global, and shadowing it would be a footgun.
 *
 * `channelData[c][i]` is the sample for channel `c` at frame `i`, a float
 * nominally in `[-1, 1]`. Every channel array has the same length.
 */
export interface PcmAudio {
  readonly sampleRate: number;
  readonly channelData: Float32Array[];
}

/** Number of channels in a {@link PcmAudio} buffer. */
export function numberOfChannels(audio: PcmAudio): number {
  return audio.channelData.length;
}

/** Number of sample frames (per channel). 0 if there are no channels. */
export function frameCount(audio: PcmAudio): number {
  return audio.channelData[0]?.length ?? 0;
}

/** Duration in seconds. */
export function durationSeconds(audio: PcmAudio): number {
  if (audio.sampleRate <= 0) return 0;
  return frameCount(audio) / audio.sampleRate;
}
